import type { ArchivedItemsDialogState } from '@common/utils'
import {
  MolsonButton,
  MolsonDialog,
  MolsonDialogActions,
  MolsonDialogContent,
  MolsonDialogHeader
} from '@components/reusable'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ArchivedItem } from '../archived-item/ArchivedItem'

type AddAttachmentDialogProps = {
  dialogState: ArchivedItemsDialogState
  keyPrefix: string
  onClose: () => void
  openNextDialog?: () => void
  addSpecToQuotation?: (specId: string) => Promise<void> | void
}

export const ArchivedItemsDialog = ({
  dialogState,
  onClose,
  keyPrefix,
  openNextDialog,
  addSpecToQuotation
}: AddAttachmentDialogProps) => {
  const [loading, setLoading] = useState(false)
  const { open, items, allItemsArchived, specId } = dialogState

  const { t } = useTranslation('', {
    keyPrefix
  })

  const handleAddToSpec = () => {
    setLoading(true)

    if (openNextDialog) {
      onClose()
      openNextDialog()
    } else {
      addSpecToQuotation?.(specId)
    }
  }

  return (
    <MolsonDialog fullWidth={true} maxWidth="md" onClose={onClose} open={open}>
      <MolsonDialogHeader
        headerIcon="ERROR_OUTLINE"
        iconColor="error"
        subTitle={
          t(
            allItemsArchived
              ? 'itemsSpecWereArchived'
              : 'itemsBrandWereArchived'
          ) ?? ''
        }
        title={t(allItemsArchived ? 'allItemsArchived' : 'archivedItemsInSpec')}
      />
      <MolsonDialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 5, mb: 0 }}
      >
        {items.map(item => (
          <ArchivedItem
            key={`${item.id}-${item.crd}`}
            item={item}
            infoText={t('archivedItem')}
          />
        ))}
      </MolsonDialogContent>
      <MolsonDialogActions>
        {!allItemsArchived && (
          <MolsonButton
            color="secondary"
            onClick={onClose}
            variant="outlined"
            disabled={loading}
          >
            {t('cancel')}
          </MolsonButton>
        )}
        <MolsonButton
          disabled={loading}
          onClick={allItemsArchived ? onClose : handleAddToSpec}
          variant="contained"
        >
          {t(allItemsArchived ? 'backToSpecs' : 'continueWithoutItem')}
        </MolsonButton>
      </MolsonDialogActions>
    </MolsonDialog>
  )
}
